// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Luna Point 2
 * Service Luna Point 2
 * Version: v.0.0.0
 */
/**
 * Prediction that a person in the image created via deepfake (or not).
 *
 * | deepfake | value |
 * |--------------|---|
 * | fake         | 0 |
 * | real         | 1 |
 */
export type DeepfakeState = typeof DeepfakeState[keyof typeof DeepfakeState];


export const DeepfakeState = {
  NUMBER_0: 0,
  NUMBER_1: 1,
} as const;
